var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.marcador)?_c('iframe',{staticStyle:{"border":"0","width":"100%","height":"30vh"},attrs:{"src":'https://maps.google.com/maps?q='+_vm.marcador.latitud + ', '+ _vm.marcador.longitud +'&z=15&output=embed',"frameborder":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }